import { FiBook, FiEdit3, FiFileText, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import styles from "./SubjectFormModal.module.css";

const SubjectFormModal = ({ isOpen, mode, values, onChange, onClose, onSubmit, saving, error }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const isCreateMode = mode === "create";
  const title = isCreateMode ? t("pages.subjectForm.createTitle") : t("pages.subjectForm.editTitle");

  return (
    <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="subject-modal-title">
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.titleWrap}>
            <span className={styles.headerIcon}>{isCreateMode ? <FiBook size={22} /> : <FiEdit3 size={22} />}</span>
            <h2 id="subject-modal-title" className={styles.title}>{title}</h2>
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label={t("pages.subjectForm.closeAria")}>
            <FiX size={20} />
          </button>
        </div>

        <form onSubmit={onSubmit} className={styles.form}>
          <div className={styles.formBody}>
            <div className={styles.formGroup}>
              <label className={styles.label}>{t("pages.subjectForm.subjectName")}</label>
              <input
                type="text"
                name="name"
                value={values.name}
                onChange={onChange}
                className={styles.input}
                placeholder={t("pages.subjectForm.subjectNamePlaceholder")}
                autoComplete="off"
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                <FiFileText size={14} className={styles.labelIcon} />
                {t("pages.subjectForm.description")}
              </label>
              <textarea
                name="description"
                value={values.description}
                onChange={onChange}
                className={styles.textarea}
                placeholder={t("pages.subjectForm.descriptionPlaceholder")}
                rows={4}
              />
            </div>

            {error && (
              <div className={styles.error} role="alert">
                {error}
              </div>
            )}
          </div>

          <div className={styles.actions}>
            <button type="button" onClick={onClose} className={styles.secondaryBtn}>
              {t("common.cancel")}
            </button>
            <button type="submit" disabled={saving} className={styles.primaryBtn}>
              {saving ? t("pages.subjectForm.saving") : isCreateMode ? t("pages.subjectForm.addBtn") : t("pages.subjectForm.saveBtn")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubjectFormModal;
